module.exports = __webpack_public_path__ + "img/maingallery_01.02e20f6d.jpg";